export default "__VITE_ASSET__w3$kZ6HT7OGRkxfr9TIcDQ__"